import { useSearchParams } from "react-router-dom";
import { useTenant } from "@/contexts/TenantContext";
import { useDomain } from "@/hooks/useDomain";

const VALID_TYPES = ["all", "physical", "digital", "journal"] as const;
export type GuestCatalogType = (typeof VALID_TYPES)[number];

export function parseGuestCatalogType(value: string | null): GuestCatalogType {
  if (value && (VALID_TYPES as readonly string[]).includes(value)) {
    return value as GuestCatalogType;
  }
  return "all";
}

/** Tenant slug for guest OPAC — prefers live tenant context over stale sessionStorage. */
export function useGuestOpacTenantSlug(): string | undefined {
  const { tenant } = useTenant();
  const [searchParams] = useSearchParams();
  const { tenantSlug: domainSlug } = useDomain();

  return tenant?.slug ?? searchParams.get("tenantSlug") ?? domainSlug ?? undefined;
}
